import { AxiosResponse } from 'axios';

// TODO: Implement fetchQueryData function and props
export interface IFetchSearchQueryDataProps {
}

// eslint-disable-next-line no-empty-pattern
export function fetchSearchQueryData({}) {
  return new Promise<AxiosResponse>((resolve) => {
    resolve({} as AxiosResponse);
  });
}
